export type Lang = 'id' | 'en';

const dict = {
  id: {
    appName: 'Tempmail',
    tagline: 'Email sementara gratis — privat & otomatis terhapus',
    copy: 'Salin',
    copied: 'Disalin!',
    refresh: 'Segarkan',
    newAddress: 'Baru',
    delete: 'Hapus',
    random: 'Acak',
    custom: 'Kustom',
    username: 'Username',
    domain: 'Domain',
    create: 'Buat',
    cancel: 'Batal',
    inbox: 'Kotak masuk',
    emptyTitle: 'Belum ada email',
    emptyDesc: 'Kirim email ke alamat di atas. Pesan baru akan muncul otomatis.',
    fetching: 'Memeriksa email…',
    from: 'Dari',
    subject: 'Subjek',
    noSubject: '(tanpa subjek)',
    received: 'Diterima',
    plainText: 'Teks',
    html: 'HTML',
    rawEml: 'Unduh EML',
    attachments: 'Lampiran',
    download: 'Unduh',
    back: 'Kembali',
    admin: 'Admin',
    login: 'Masuk',
    logout: 'Keluar',
    password: 'Kata sandi',
    setup: 'Setup awal',
    setupDesc: 'Buat kata sandi admin untuk pertama kali.',
    bootstrapSecret: 'Bootstrap secret (opsional)',
    domains: 'Domain',
    addDomain: 'Tambah domain',
    domainName: 'Nama domain',
    active: 'Aktif',
    inactive: 'Nonaktif',
    actions: 'Aksi',
    stats: 'Statistik',
    mailboxes: 'Mailbox',
    emails: 'Email',
    settings: 'Pengaturan',
    siteName: 'Nama situs',
    ttlHours: 'TTL (jam)',
    save: 'Simpan',
    saved: 'Tersimpan',
    changePassword: 'Ganti password',
    newPassword: 'Password baru',
    noDomains: 'Belum ada domain aktif. Minta admin menambahkan domain.',
    errorGeneric: 'Terjadi kesalahan',
    confirmDeleteMailbox: 'Hapus mailbox ini beserta semua emailnya?',
    confirmDeleteDomain: 'Hapus domain ini?',
    loading: 'Memuat…',
    light: 'Terang',
    dark: 'Gelap',
    language: 'Bahasa',
    selectEmail: 'Pilih email untuk membaca',
    attachmentUnavailable: 'Konten lampiran tidak tersedia',
    maxAttachment: 'Maks. lampiran (byte)',
    home: 'Beranda',
    dashboard: 'Dasbor',
    toggle: 'Aktif/Nonaktif',
    openInbox: 'Buka Tempmail',
    mailboxesAdmin: 'Mailbox',
    manageMailboxes: 'Kelola Mailbox',
    manageMailboxesDesc: 'Hapus mailbox manual agar alamat bisa dipakai ulang.',
    searchMailbox: 'Cari alamat email…',
    search: 'Cari',
    clear: 'Bersihkan',
    address: 'Alamat',
    emailCount: 'Email',
    lastAccess: 'Akses terakhir',
    created: 'Dibuat',
    noMailboxes: 'Belum ada mailbox.',
    confirmDeleteMailboxAdmin: 'Hapus mailbox ini beserta semua emailnya? Alamat bisa dipakai ulang setelah dihapus.',
    deletedMailbox: 'Mailbox dihapus',
    filterDomain: 'Semua domain',
  },
  en: {
    appName: 'Tempmail',
    tagline: 'Free temporary email — private & auto-deleted',
    copy: 'Copy',
    copied: 'Copied!',
    refresh: 'Refresh',
    newAddress: 'New',
    delete: 'Delete',
    random: 'Random',
    custom: 'Custom',
    username: 'Username',
    domain: 'Domain',
    create: 'Create',
    cancel: 'Cancel',
    inbox: 'Inbox',
    emptyTitle: 'No emails yet',
    emptyDesc: 'Send mail to the address above. New messages appear automatically.',
    fetching: 'Checking for mail…',
    from: 'From',
    subject: 'Subject',
    noSubject: '(no subject)',
    received: 'Received',
    plainText: 'Text',
    html: 'HTML',
    rawEml: 'Download EML',
    attachments: 'Attachments',
    download: 'Download',
    back: 'Back',
    admin: 'Admin',
    login: 'Sign in',
    logout: 'Sign out',
    password: 'Password',
    setup: 'Initial setup',
    setupDesc: 'Create an admin password for the first time.',
    bootstrapSecret: 'Bootstrap secret (optional)',
    domains: 'Domains',
    addDomain: 'Add domain',
    domainName: 'Domain name',
    active: 'Active',
    inactive: 'Inactive',
    actions: 'Actions',
    stats: 'Stats',
    mailboxes: 'Mailboxes',
    emails: 'Emails',
    settings: 'Settings',
    siteName: 'Site name',
    ttlHours: 'TTL (hours)',
    save: 'Save',
    saved: 'Saved',
    changePassword: 'Change password',
    newPassword: 'New password',
    noDomains: 'No active domains. Ask an admin to add one.',
    errorGeneric: 'Something went wrong',
    confirmDeleteMailbox: 'Delete this mailbox and all its emails?',
    confirmDeleteDomain: 'Delete this domain?',
    loading: 'Loading…',
    light: 'Light',
    dark: 'Dark',
    language: 'Language',
    selectEmail: 'Select an email to read',
    attachmentUnavailable: 'Attachment content unavailable',
    maxAttachment: 'Max attachment (bytes)',
    home: 'Home',
    dashboard: 'Dashboard',
    toggle: 'Toggle',
    openInbox: 'Open Tempmail',
    mailboxesAdmin: 'Mailboxes',
    manageMailboxes: 'Manage Mailboxes',
    manageMailboxesDesc: 'Manually delete a mailbox so its address can be reused.',
    searchMailbox: 'Search email address…',
    search: 'Search',
    clear: 'Clear',
    address: 'Address',
    emailCount: 'Emails',
    lastAccess: 'Last access',
    created: 'Created',
    noMailboxes: 'No mailboxes yet.',
    confirmDeleteMailboxAdmin: 'Delete this mailbox and all its emails? The address can be reused after deletion.',
    deletedMailbox: 'Mailbox deleted',
    filterDomain: 'All domains',
  },
} as const;

export type TranslationKey = keyof typeof dict.en;

export function t(lang: Lang, key: TranslationKey): string {
  return dict[lang][key] ?? dict.en[key] ?? key;
}

export function detectLang(): Lang {
  try {
    const saved = localStorage.getItem('tempmail_lang');
    if (saved === 'id' || saved === 'en') return saved;
  } catch {
    /* ignore */
  }
  const nav = typeof navigator !== 'undefined' ? navigator.language.toLowerCase() : 'en';
  return nav.startsWith('id') ? 'id' : 'en';
}
